// Module
var code = `<div class="pricing-card-inner">
    <div class="pricing-label p">{{label}}</div>
    <div class="pricing-head p">
<!--
        <p>head: {{pricingHead}}</p>
-->
        <p>{{desc}}</p>

        <div class="pricing-cost">{{pricingCost}}</div>
    </div >
    <div class="pricing-list">
<!--
        <p>{{pricingListHead}}</p>
-->

        <ul>
            {{#features}}
            <li><i class="fa-solid2 fa-utility fa-semibold fa-check"></i><p>{{.*}}</p></li>
            {{/features}}

        </ul>

    </div>

    <div class="pricing-cta">
        <button data-event-type="authEvent" data-is-pricing-event="true" data-pricing-type="{{type}}" ><span>{{buttonText}}<i class="fa-solid2 fa-utility fa-semibold fa-arrow-right"></i></span></button>
    </div>

</div>
`;
// Exports
module.exports = code;